var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"container_echarts",staticStyle:{"min-height":"400px","width":"700px"},attrs:{"id":_vm.uuid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }